import { render, staticRenderFns } from "./ModalSMSPreview.vue?vue&type=template&id=49074980&scoped=true&"
import script from "./ModalSMSPreview.vue?vue&type=script&lang=js&"
export * from "./ModalSMSPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49074980",
  null
  
)

export default component.exports